export default {
    inserted: (el, binding) => {
        const node = binding.modifiers.parent ? el.parentNode : el;
        const value = node.offsetWidth < node.scrollWidth;
        if (typeof binding.value === 'function') {
            binding.value(value);
        }

        else {
            binding.value = value;
        };
    }
};